/* eslint-disable no-unused-vars */
import VWDigitalSignage from 'modules/Conference/components/DigitalSignage/VWDigitalSignage';
import MiddlewareRegistry from '../base/redux/MiddlewareRegistry';
import { openDialog, hideDialog } from '../base/dialog';
import { SET_SETTINGS, SET_VIDEO_ONLY } from './actionTypes';
import { updateSleepSettings } from './actions';

MiddlewareRegistry.register(({ dispatch, getState }) => (next) => (action) => {
  const { userDigitalSignageMode } = getState()['features/settings'];
  const result = next(action);

  switch (action.type) {
    case SET_VIDEO_ONLY: {
      if (!action.value) {
        if (userDigitalSignageMode)
          dispatch(
            updateSleepSettings({
              userDigitalSignageMode: false
            })
          );
      } else {
        // eslint-disable-next-line no-undef
        // APP.conference.checkDigitalSignage();
      }
      break;
    }

    case SET_SETTINGS: {
      const {
        userDigitalSignageMode: newSignageMode,
        digitalSignageOptions: newSignageOptions,
        userBrowserMode: newBrowserMode
      } = getState()['features/settings'];
      const oddRotation = getState()['features/large-video'].oddRotation;
      const activeParticipants =
        getState()['features/filmstrip'].activeParticipants;
      const isDialog = getState()['features/base/dialog'].componentName;
      if (
        newSignageMode &&
        newSignageOptions.signageStyle !== 'side-by-side' &&
        !activeParticipants.length &&
        !oddRotation &&
        !newBrowserMode
      ) {
        dispatch(
          openDialog(VWDigitalSignage, 'DigitalSignage', {
            options: newSignageOptions
          })
        );
      }
      //Handles onJoinLeaveAudio or active oddRotation clearing of dialog signage
      if (isDialog === 'DigitalSignage' && (!newSignageMode || oddRotation)) {
        dispatch(hideDialog('DigitalSignage'));
      }
      break;
    }
  }

  return result;
});
